// La impresión que la persona quiere dar (pregunta «¿Qué querés que piense alguien cuando entra a tu sitio?»).
// Los textos de las opciones viven en flows.js y pueden cambiar de redacción; las pantallas de la web (WebChat, Dashboard)
// no se atan al texto: usan esta clave. Antes el texto exacto era la llave y un cambio de redacción desarmó el vínculo (18/10/2026).
export const claveImpresion = (feeling = '') => {
  const f = String(feeling).toLowerCase();
  if (f.includes('exactamente')) return 'exacto';
  if (f.includes('saber m')) return 'saber';
  if (f.includes('confianza')) return 'confianza';
  if (f.includes('ahora mismo')) return 'ahora';
  return null;
};

// Para mostrar la frase sin las comillas de la opción.
export const sinComillas = (feeling = '') => String(feeling).replace(/["«»]/g, '');
